import {
  EBadgePosition,
  EBadgeType,
  ESaleDiscountDisplayType,
} from 'utils/enums';
import { Gradient } from 'utils/types';

interface Emblem {
  imageUrl: string;
}

interface Ribbon {
  text: string;
  backgroundColor: Gradient;
  textColor: Gradient;
}

// TODO: merge emblem + ribbon under one key
export interface BadgeData {
  type: EBadgeType;
  emblem?: Emblem;
  ribbon?: Ribbon;
  badge?: any;
  salePercentage?: number;
  name?: string;
  className?: string;
}

export interface RibbonBadge {
  publisherBadgeId: string;
  badgeName: string;
  text: string;
  backgroundColor: Gradient;
  textColor: Gradient;
}

export interface EmblemBadge {
  publisherBadgeId: string;
  badgeName: string;
  emblemUrl: string;
}

export interface SaleBadgeProps {
  salePercentage: number;
  salePercentageDisplayType?: ESaleDiscountDisplayType;
  amountAfterSale?: number;
  position?: EBadgePosition;
  text?: string;
  designType?: EBadgeDesignType;
  type?: EBadgeType;
}

export enum EBadgeDesignType {
  CORNER = 'corner',
  MIDDLE = 'middle',
}
